import React from "react";
import { Select } from "../../../../../../shared/infrastructure/ui";
import { SelectComponentProps } from "./types";
import { useInfiniteGetCommodities } from "../../../services";
import { withSelectOptions } from "./with-select-options";
import {
  CommodityT,
  UseGetCommodityFilters,
} from "../../../../domain/entities";

const RenderOption = ({
  description,
  commodity_id,
}: CommodityT): React.ReactElement => {
  return (
    <section className="grid w-[300px] grid-flow-col items-center justify-between px-[5px] text-[12px]">
      <span>{description ?? "- -"}</span>
      <span className="rounded-[5px] bg-[#F4F4F4] py-[5px] px-[10px] text-[10px]">
        {commodity_id ?? "- -"}
      </span>
    </section>
  );
};

const CommoditySelectComponent = ({
  placeholder,
  name = "",
  selectedValue,
  onChangeValue,
  error = "",
  variant = "standard",
  disabled = false,
  handleSetKeyword,
  isLoading,
  getNextPage,
  noMore,
  data,
  noError,
  labelProp = "description",
  keyword,
  multiselect,
}: SelectComponentProps<CommodityT>): React.ReactElement => {
  return (
    <Select<CommodityT>
      searchValue={keyword}
      multiselect={multiselect}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      options={data}
      name={name}
      asyncFilter={handleSetKeyword}
      labelProp={labelProp}
      value={selectedValue}
      onChange={onChangeValue}
      noMore={noMore}
      getMore={getNextPage}
      renderOptionComponent={RenderOption}
      error={error}
      variant={variant}
      noError={noError}
    />
  );
};

export const CommoditySelect = withSelectOptions<
  CommodityT,
  UseGetCommodityFilters
>(CommoditySelectComponent, useInfiniteGetCommodities, "commodity");
